import ConnectionSettings from '../settings/Settings'
import styles from './ManageConnection.module.scss'

const ManageConnectionSettings = () => (
  <div className={styles.settingsContent}>
    <ConnectionSettings />
  </div>
)

export default ManageConnectionSettings
